
import { setPaidStatus } from '@/api/task/withdraw'
import { setOrderStatusRules } from '@/utils/rules'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { AppModule } from '@/store/modules/app'
import PicsUploader from '@/components/PicsUploader/index.vue'

@Component({
  name: 'setPaidInfo',
  components: { PicsUploader },
})
export default class extends Vue {
  @Prop({ required: true }) private info!: any
  get language() {
    return AppModule.language
  }
  private statusList: any[] = []
  private setForm: any = {
    status: null,
    remarks: '',
    // google_code: ''
  }
  private rules = setOrderStatusRules
  private loading: boolean = false
  private show: boolean = false

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  // 上传图片
  private getPicList(fileList: any) {
    this.setForm.attach = fileList.map((item: any) => {
      return item.response.file_path
    })
  }

  private changeStatus(i) {
    if (i === 1) {
      this.show = true
    } else {
      this.show = false
    }
  }

  private back(is: boolean) {
    this.setForm = {
      status: null,
      remarks: '',
      // google_code: ''
    }
    this.loading = false
    this.$emit('close', is)
  }

  private async setPaidStatus() {
    ;(this.$refs.setForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true
        let { status, remarks, description, attach } = this.setForm
        const data: any = {
          ordernumber: this.info.ordernumber,
          status,
          remarks,
          description,
          attach,
        }
        try {
          await setPaidStatus(data).then(() => {
            if (this.language === 'en') {
              this.$message({
                message:
                  'The task was created successfully, please contact another administrator for approval!',
                type: 'success',
              })
            }
            if (this.language === 'zh_cn') {
              this.$message({
                message: '任务创建成功，请联系其他管理员审批!',
                type: 'success',
              })
            }
            if (this.language === 'zh_tw') {
              this.$message({
                message: '任務創建成功，請聯系其他管理員審批!',
                type: 'success',
              })
            }
            this.loading = false
            this.flagStr()
            this.back(true)
          })
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      }
    })
  }

  async created() {
    await AppModule.GetConstant().then((res: any) => {
      this.statusList = res.WITHDRAW_ORDER_STATUS
    })
  }
}
